import ChargingIcon from "../assets/Charging.svg";
import ColdstandbyIcon from "../assets/Coldstandby.svg";
import CooldownIcon from "../assets/Cooldown.svg";
import CoolingIcon from "../assets/Cooling.svg";
import FaultIcon from "../assets/Fault.svg";
import HotstandbyIcon from "../assets/Hotstandby.svg";
import IdleIcon from "../assets/Idle.svg";
import LowPressureIcon from "../assets/Low Pressure.svg";
import MaintenanceIcon from "../assets/Maintenance.svg";
import MoveIcon from "../assets/Move.svg";
import OffIcon from "../assets/Off.svg";
import OnlineIcon from "../assets/Online.svg";
import PreparingForStandbyIcon from "../assets/Preparing for standby.svg";
import ProducingIcon from "../assets/Producing.svg";
import ProductionIcon from "../assets/Production.svg";
import StandbyIcon from "../assets/Standby.svg";
import WarmingIcon from "../assets/Warming.svg";
export const getMethanolStatusBadge = (status) => {
    if (!status)
        return null;
    const normalised = status.toLowerCase().replace(/\s+/g, "");
    switch (normalised) {
        case "charging":
            return ChargingIcon;
        case "lowpressure":
            return LowPressureIcon;
        case "producing":
            return ProducingIcon;
        case "production":
            return ProductionIcon;
        case "warming":
            return WarmingIcon;
        case "cooling":
            return CoolingIcon;
        case "cooldown":
            return CooldownIcon;
        case "move":
            return MoveIcon;
        case "fault":
            return FaultIcon;
        case "off":
            return OffIcon;
        case "idle":
            return IdleIcon;
        case "maintenance":
            return MaintenanceIcon;
        case "online":
            return OnlineIcon;
        case "hotstandby":
            return HotstandbyIcon;
        case "coldstandby":
            return ColdstandbyIcon;
        case "preparingforstandby":
            return PreparingForStandbyIcon;
        case "standby":
            return StandbyIcon;
        default:
            return null;
    }
};
